import { createContext, useContext } from 'react'

export interface SearchContextValue {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

export const SearchContext = createContext<SearchContextValue | null>(null)

/**
 * Access the global command-palette state. Lives here (not in
 * `search-context.tsx`) so the provider file only exports a component —
 * keeps React Fast Refresh working.
 */
export function useSearch(): SearchContextValue {
  const ctx = useContext(SearchContext)
  if (!ctx) {
    throw new Error('useSearch must be used within a <SearchProvider>')
  }
  return ctx
}
